import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, TextField} from "@mui/material";
import React, {useState} from "react";
import {ApplicantParty} from "../api/types/Applicant";
import {LoadingButton} from "@mui/lab";

interface EditClientPartyDialogProps {
    party: ApplicantParty;
    children: (handleOpen: () => void, handleClose: () => void) => React.ReactNode;
    onEdit: (payload: EditClientPartyDialogState) => void;
}

interface EditClientPartyDialogState {
    name: string
}

const EditClientPartyDialog = ({party, children, onEdit}: EditClientPartyDialogProps) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [partyName, setPartyName] = useState<string>(party.name);
    const [processing, setProcessing] = useState<boolean>(false);

    const open = () => {
        setDialogOpen(true);
    }

    const close = () => {
        setDialogOpen(false);
    }

    const handleEditClick = async () => {
        if (onEdit) {
            setProcessing(true);
            await onEdit({name: partyName});
            setProcessing(false);
        }
        close();
    };


    const handleKeyPress = async (e: React.KeyboardEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (e.key === 'Enter') {
            await handleEditClick();
        }
    }

    return (
            <>
                {typeof children === 'function' ? children(open, close) : children}

                <Dialog
                        open={dialogOpen}
                        onClose={close}
                >
                    <DialogTitle>Edit party</DialogTitle>
                    <DialogContent sx={{minWidth: 400}} style={{paddingTop: 5}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                        autoFocus
                                        required
                                        id="name"
                                        name="name"
                                        label="Name"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={partyName}
                                        onChange={(e) => setPartyName(e.target.value)}
                                        onKeyDown={e => handleKeyPress(e)}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button color={"error"} onClick={close}>Cancel</Button>
                        <LoadingButton variant={"contained"} onClick={handleEditClick} loading={processing}>
                            Edit
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </>
    )
}

export default EditClientPartyDialog;